import { Link } from 'react-router-dom';
import { featuredArticles, articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { faqs } from '@/mocks/faqs';
import ArticleCard from '@/components/feature/ArticleCard';

export default function Home() {
  const latestArticles = articles.slice(0, 6);

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "url": "https://cnyangji.cn/",
    "name": "色戒无删减版｜完整版在线观看指南",
    "description": "想看色戒无删减版？本页为您详细介绍色戒无删减版的版本差异、剧情解析、导演李安创作背景及正版高清资源获取渠道。",
    "inLanguage": "zh-CN",
  };

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "https://cnyangji.cn/",
      },
    ],
  };

  const categoryDataMap: Record<string, { image: string; seq: string }> = {
    'plot-analysis': {
      image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20film%20analysis%20scene%20with%20warm%20cinematic%20lighting%2C%201940s%20period%20drama%20aesthetic%2C%20film%20critique%20atmosphere%2C%20soft%20golden%20amber%20tones%2C%20vintage%20movie%20poster%20design%2C%20elegant%20minimal%20composition&width=400&height=300&seq=cat-plot-analysis&orientation=landscape',
      seq: 'cat-plot-analysis',
    },
    'version-comparison': {
      image: 'https://readdy.ai/api/search-image?query=Film%20comparison%20split%20screen%20concept%2C%20classic%20movie%20reel%20and%20film%20strip%20aesthetic%2C%20warm%20vintage%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20double%20exposure%2C%20soft%20golden%20lighting%20with%20dark%20accents&width=400&height=300&seq=cat-version-compare&orientation=landscape',
      seq: 'cat-version-compare',
    },
    'creation-background': {
      image: 'https://readdy.ai/api/search-image?query=Film%20director%20working%20on%20movie%20set%20with%20vintage%20camera%2C%20behind%20the%20scenes%20documentary%20style%2C%20warm%20cinematic%20lighting%2C%20classic%20film%20production%20atmosphere%2C%20soft%20amber%20and%20gold%20tones%2C%20artistic%20composition&width=400&height=300&seq=cat-creation-bg&orientation=landscape',
      seq: 'cat-creation-bg',
    },
    'resource-guide': {
      image: 'https://readdy.ai/api/search-image?query=Home%20cinema%20entertainment%20setup%20with%20classic%20film%20collection%2C%20warm%20cozy%20lighting%2C%20vintage%20movie%20posters%2C%20elegant%20living%20room%20aesthetic%2C%20soft%20golden%20ambient%20light%2C%20premium%20home%20theater%20atmosphere&width=400&height=300&seq=cat-resource&orientation=landscape',
      seq: 'cat-resource',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}></script>
      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%201940s%20Shanghai%20street%20at%20night%20with%20warm%20amber%20street%20lamps%2C%20art%20deco%20architecture%2C%20classic%20Chinese%20cinema%20aesthetic%2C%20moody%20atmospheric%20fog%2C%20film%20noir%20visual%20style%2C%20elegant%20silhouettes%2C%20soft%20golden%20and%20brown%20tones%2C%20nostalgic%20romantic%20vibe&width=1600&height=900&seq=hero-sejie-main&orientation=landscape"
            alt="色戒无删减版 - 完整版在线观看指南"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <div className="text-center max-w-3xl">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 tracking-tight leading-tight">
              色戒无删减版｜完整版在线观看指南
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
              全面了解李安导演经典之作《色戒》无删减版的版本差异、剧情解析、创作背景及正版高清资源获取渠道
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
              <Link
                to="/article/sejie-uncut-full-analysis"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                阅读完整解析
              </Link>
              <Link
                to="/category/resource-guide"
                className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-lg font-medium text-sm hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看资源指南
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const data = categoryDataMap[cat.slug];
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group relative rounded-lg overflow-hidden h-40 cursor-pointer"
              >
                <img
                  src={data.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <i className={`${cat.icon} text-white/90 text-sm`}></i>
                    <span className="text-white font-semibold text-sm">{cat.name}</span>
                  </div>
                  <span className="text-white/60 text-xs">{cat.count} 篇文章</span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      {/* Featured Articles */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 pb-12">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
            <i className="ri-star-line text-accent-500 mr-2"></i>
            精选推荐
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
      </section>

      {/* Latest Articles */}
      <section className="bg-background-100/50 py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
              <i className="ri-article-line text-foreground-500 mr-2"></i>
              最新文章
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="max-w-3xl mx-auto px-4 md:px-6 py-14">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 text-center mb-8">
          <i className="ri-question-answer-line text-primary-500 mr-2"></i>
          常见问题
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-900 hover:text-primary-500 transition-colors">
                {faq.question}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative w-full py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20golden%20light%20rays%2C%20vintage%20film%20texture%20overlay%2C%20elegant%20art%20deco%20patterns%2C%20classic%20cinema%20atmosphere%2C%20luxurious%20amber%20and%20brown%20gradient%2C%20nostalgic%20movie%20theater%20vibe&width=1600&height=800&seq=cta-sejie-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-4">
            发现《色戒》的完整艺术魅力
          </h2>
          <p className="text-white/70 text-sm md:text-base mb-8 max-w-xl mx-auto">
            深入了解李安导演的完整创作表达，探索这部华语电影杰作的每一个隐藏细节
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/article/sejie-cut-vs-uncut-comparison"
              className="px-6 py-3 bg-accent-500 text-background-50 rounded-lg font-medium text-sm hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看版本对比
            </Link>
            <Link
              to="/category/creation-background"
              className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-lg font-medium text-sm hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解创作背景
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}